export const batchEnrollmentIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'User List is where you can add teacher and school reports users for your school.',
  },
  {
    element: '#upload-label',
    intro: 'Click here to select a properly formatted Excel spreadsheet to upload.',
  },
  {
    element: '#remove-button',
    intro: 'Click here to remove the file that you uploaded.',
  },
  {
    element: '#undo-button',
    intro: 'Click here to undo the last enrollment submission.',
  },
  {
    element: '#enroll-button',
    intro: 'Click here to finish enrollment for the uploaded file',
  },
  {
    element: '#example-link',
    intro: 'Click here to access an example correctly formatted Excel spreadsheet.',
  },
];
